<div class="col-12" *ngIf="group">
  <div class="overlayParent">
    <div class="overlay" *ngIf="saving"></div>
    <div
      class="card"
      *ngIf="!(editEntry == true) && !(group.identifier == 'new')"
    >
      <div class="card-header font-weight-bold" *ngIf="isUser">
        User Group ID:
        <a href="" (click)="toGroup($event, group.identifier)">{{
          group.identifier
        }}</a>
      </div>
      <div class="card-header font-weight-bold" *ngIf="!isUser">
        User Group ID: {{ group.identifier }}
      </div>
      <div class="card-body card-block">
        <!-- ✅ System/Group Details Section -->
        <div class="card border-success mb-3">
          <div class="card-header bg-success text-white font-weight-bold">
            User Group Details:
          </div>
          <div class="card-body b-0">
            <div class="row" *ngIf="group.system === true">
              <div class="col-3 font-weight-bold">System Group:</div>
              <div class="col-9">True</div>
            </div>
            <div class="row">
              <div class="col-3 font-weight-bold">Name:</div>
              <div class="col-9">{{ group.name }}</div>
            </div>
            <div class="row">
              <div class="col-3 font-weight-bold">Description:</div>
              <div class="col-9">{{ group.description }}</div>
            </div>
            <div class="row" *ngIf="group.handle">
              <div class="col-3 font-weight-bold">Handle:</div>
              <div class="col-9">{{ group.handle }}</div>
            </div>
            <div class="row" *ngIf="group.createdOn">
              <div class="col-3 font-weight-bold">Created On:</div>
              <div class="col-9">{{ group.createdOn }}</div>
            </div>
            <div class="row" *ngIf="group.modifiedOn">
              <div class="col-3 font-weight-bold">Modified On:</div>
              <div class="col-9">{{ group.modifiedOn }}</div>
            </div>
          </div>
        </div>

        <div class="card border-warning mb-3">
          <div class="card-header bg-warning text-dark font-weight-bold">
            Assigned Groups:
          </div>

          <div class="card-body mb-0" *ngIf="loadingGroups">
            <new-spinner [size]="'sm'"></new-spinner>
          </div>

          <div
            class="card-body mb-0"
            *ngIf="!loadingGroups && groupName?.length === 0"
          >
            <div class="row">
              <div class="col-12">No assigned groups</div>
            </div>
          </div>

          <div
            class="card-body mb-0"
            *ngIf="
              !loadingGroups &&
              group.memberOf?.length > 0 &&
              groupName?.length === group.memberOf.length
            "
          >
            <div class="row" *ngFor="let group of groupName">
              <div class="col-3 font-weight-bold">
                <a href="/portal/groups/show/{{ group.id }}/{{ uid }}">{{
                  group.id
                }}</a>
              </div>
              <div class="col-9" (click)="toGroup($event, group.id)">
                {{ group.name }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="card border-info mb-3"
          *ngIf="group.system !== true && effective_permissions"
        >
          <div class="card-header bg-info text-white font-weight-bold">
            User Permissions:
          </div>
          <div class="card-body">
            <ng-container
              *ngIf="effective_permissions | keyvalue as permissions"
            >
              <div *ngIf="permissions.length > 0; else noPermissions">
                <div class="row mb-2" *ngFor="let perm of permissions">
                  <div class="col-3 font-weight-bold">{{ perm.key }}:</div>
                  <div class="col-9">
                    <span
                      class="badge rounded-pill text-white px-3 py-1"
                      [ngClass]="{
                        'bg-success': perm.value == '1',
                        'bg-danger': perm.value != '1'
                      }"
                    >
                      {{ perm.value == "1" ? "granted" : "denied" }}
                    </span>
                  </div>
                </div>
              </div>
              <ng-template #noPermissions>
                <div>No admin permissions</div>
              </ng-template>
            </ng-container>
          </div>
        </div>

        <!-- ✅ Edit Button -->
        <button
          class="btn btn-primary pull-right"
          (click)="edit($event, entry)"
        >
          Edit Group and Membership
        </button>
      </div>
    </div>
    <div class="card" *ngIf="editEntry == true || group.identifier == 'new'">
      <div class="card-block row card-body">
        <div class="col-12">
          <form action="" class="form-horizontal">
            <div class="form-group row">
              <label class="col-3 form-control-label" for="edit-handle"
                >Name</label
              >
              <div class="col-9">
                <input
                  class="form-control"
                  id="group-name"
                  name="group.name"
                  placeholder="Name"
                  type="text"
                  [(ngModel)]="group.name"
                  autocomplete="off"
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-3 form-control-label" for="edit-email"
                >Description</label
              >
              <div class="col-9">
                <input
                  class="form-control"
                  id="group-description"
                  name="group.description"
                  placeholder="Description"
                  type="text"
                  [(ngModel)]="group.description"
                  autocomplete="off"
                />
              </div>
            </div>

            <div class="form-group row">
              <!-- *ngIf="user.auth.permissionLevel <=1" -->
              <label class="col-3 form-control-label" for="edit-isSystem"
                >Is System Group</label
              >
              <div class="col-9">
                <input
                  type="checkbox"
                  [checked]="group.system"
                  (change)="group.system = !group.system"
                />
              </div>
            </div>
          </form>
        </div>
        <div class="col-6 mb-3">
          <input
            class="form-control"
            [(ngModel)]="gidSelect"
            placeholder="New Group ID"
            type="text"
            name="name"
          />
        </div>
        <div class="col-6">
          <button
            class="btn btn-sm btn-primary offset-1"
            (click)="addGroup($event)"
          >
            Add Group by ID
          </button>
        </div>
        <div class="col-6 mb-6" *ngIf="sysGroups.length > 0">
          <select
            name="sysgid"
            [(ngModel)]="sysGid"
            style="color: black"
            class="form-control"
          >
            <option *ngFor="let sysGroup of sysGroups" [value]="sysGroup.id">
              {{ sysGroup.name }}
            </option>
          </select>
        </div>
        <div class="col-6">
          <button
            class="btn btn-sm btn-primary offset-1"
            (click)="addSysGroup($event)"
          >
            Add System Group
          </button>
        </div>
        <div class="col-12 row my-2">
          <div class="col-3 float-left">Member of Group:</div>
          <div class="col-9 float-left">
            <div class="row" *ngFor="let gid of groupsList">
              <div class="col-12 row my-2">
                <div class="col-6">
                  {{ gid }}
                </div>
                <div class="col-6">
                  <button
                    *ngIf="gid != '5656088712052736'"
                    class="btn btn-sm btn-primary"
                    (click)="leaveGroup($event, gid)"
                  >
                    Remove Group
                  </button>
                  <span
                    *ngIf="gid == '5656088712052736'"
                    class="btn btn-sm btn-danger disabled"
                    style="pointer-events: none"
                  >
                    Default group cannot be removed.
                  </span>
                </div>
                <hr class="col-12 my-2" />
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer col-12">
          <button
            (click)="cancel($event)"
            class="btn btn-sm btn-primary"
            type="submit"
          >
            <i class="fa fa-dot-circle-o"></i> Cancel
          </button>
          <button
            (click)="update($event, entry)"
            class="btn btn-sm btn-primary float-right"
            type="submit"
          >
            <i class="fa fa-dot-circle-o"></i>Update
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="errors.show"
    class="col-12 alert alert-warning"
    (click)="errors.show = false"
  >
    {{ errors.msg }}
  </div>
</div>
